
import { mapState } from "vuex";

import { tagableMixin, metaColourMixin } from "~/mixins";

export default {
  mixins: [tagableMixin, metaColourMixin],

  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
    tags: { type: Array, default: () => [] },
    colorVariantTile: { type: Object, default: () => ({}) },
    inStoreColorsText: { type: String, default: "" },
    title: { type: String, default: "" },
  },

  computed: {
    ...mapState("app", ["topBannerHeight"]),
    colorTiles() {
      return this.colorVariantTile?.tiles.filter(
        tile => tile.targetVariantId !== null
      );
    },
    instoreColorsText() {
      return this.hasMoreColorsInstore && this.inStoreColorsText
        ? this.inStoreColorsText
        : "";
    },
  },

  methods: {
    scrollToReviews() {
      const reviewInstance = document.getElementById("pdp-reviews-accordion");

      if (reviewInstance) {
        const reviewAccordion = reviewInstance.querySelector(
          ".accordion-item.closed"
        );

        if (reviewAccordion) {
          reviewAccordion.click();
        }
        const pdpStickyHeaderHeight = 80;
        window.scrollTo({
          top:
            reviewInstance.offsetTop -
            this.topBannerHeight -
            pdpStickyHeaderHeight,
          left: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
